import { createReducer, on } from '@ngrx/store';
import * as fromAddressActions from '../actions/address.action';
export const featureKey = 'address';

export interface State {
    regions: {
        data: Array<any>,
        isLoaded: Boolean
    };
    provinces: {
        data: Array<any>,
        isLoaded: Boolean
    };
    cities: {
        data: Array<any>,
        isLoaded: Boolean
    };
    barangays: {
        data: Array<any>,
        isLoaded: Boolean
    };
}

export const initialState: State = {
    regions: {
        data: [],
        isLoaded: false
    },
    provinces: {
        data: [],
        isLoaded: false
    },
    cities: {
        data: [],
        isLoaded: false
    },
    barangays: {
        data: [],
        isLoaded: false
    },
}

export const reducer = createReducer(
    initialState,
    on(fromAddressActions.getRegionsSuccess, (state: State, props: any) => ({
        ...state,
        regions: { data: props.data, isLoaded: true },
    })),
    on(fromAddressActions.getProvincesSuccess, (state: State, props: any) => ({
        ...state,
        provinces: { data: props.data, isLoaded: true },
    })),
    on(fromAddressActions.getCitiesSuccess, (state: State, props: any) => ({
        ...state,
        cities: { data: props.data, isLoaded: true },
    })),
    on(fromAddressActions.getBarangaysSuccess, (state: State, props: any) => ({
        ...state,
        barangays: { data: props.data, isLoaded: true },
    })),
    // on(fromAuthActions.autoLogout, (state: State, props) => initialState),
);